import { Outlet } from 'react-router-dom';
import ExtensionRoute from '../../modules/core/public/ExtensionRoute';

export default function PolaroidCreatorRoutes() {
  return (
    <ExtensionRoute extensionId="polaroid-creator">
      <Outlet />
    </ExtensionRoute>
  );
}
